export default __webpack_public_path__ + "444ff7f4d80267f60c62e7a43e073187.png";